var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.currentData
    ? _c(
        "form",
        {
          ref: "form",
          attrs: { autocomplete: "off", novalidate: "" },
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _setup.save.apply(null, arguments)
            },
          },
        },
        [
          _setup.formShow
            ? _c(_setup.FormFieldsets, {
                attrs: {
                  "form-id": _vm.formId,
                  "show-legends": _vm.showLegends,
                  "hide-help-text": _vm.hideHelpText,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("Dump", [
            _vm._v(
              _vm._s({
                isModified: _setup.store.getters[_vm.formId + "/isModified"](),
                modifiedData:
                  _setup.store.getters[_vm.formId + "/modifiedData"](),
                currentData: _setup.store.state[_vm.formId].currentData,
                originalData: _setup.store.state[_vm.formId].originalData,
              }) + "\n    "
            ),
          ]),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }